export default __webpack_public_path__ + "static/media/logo-w.png?.21d93858";